
(function () {
  var colors = {black:"#111111",white:"#ffffff",red:"#c62828",pink:"#ef8bb5",blue:"#245bc7",navy:"#182b4d",cream:"#f4ead7",mint:"#a3e5cd",green:"#34854a",purple:"#713e97",orange:"#ee7f28",yellow:"#f4d443",grey:"#888888",gray:"#888888",brown:"#704832",tan:"#ceb58d",beige:"#e4d5bd",stone:"#d4cec1"};
  function colorParts(value) {
    var parts = value.toLowerCase().trim().split(/\s*(?:\/|&|\+|\band\b)\s*/);
    return parts.length <= 3 && parts.every(function (part) { return colors[part]; }) ? parts.map(function (part) { return colors[part]; }) : null;
  }
  function setup(root) {
    root.querySelectorAll(".selector-wrapper").forEach(function (wrapper) {
      if (wrapper.dataset.t5eChoices) return;
      var select = wrapper.querySelector("select.single-option-selector");
      var label = wrapper.querySelector("label");
      if (!select || !label || !/^(colou?r|colou?rway)$/i.test(label.textContent.trim())) return;
      var group = document.createElement("div");
      group.className = "t5e-color-choices";
      group.setAttribute("role", "group");
      group.setAttribute("aria-label", label.textContent.trim());
      Array.from(select.options).forEach(function (option) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "t5e-color-choice";
        button.dataset.value = option.value;
        var parts = colorParts(option.value);
        if (parts) {
          var swatch = document.createElement("span");
          swatch.className = "t5e-color-swatch";
          swatch.setAttribute("aria-hidden", "true");
          swatch.style.background = parts.length === 1 ? parts[0] : "linear-gradient(135deg," + parts.map(function(color, index) { return color + " " + (index * 100 / parts.length) + "%," + color + " " + ((index + 1) * 100 / parts.length) + "%"; }).join(",") + ")";
          button.appendChild(swatch);
        }
        var name = document.createElement("span");
        name.textContent = option.textContent;
        button.appendChild(name);
        button.addEventListener("click", function () {
          select.value = option.value;
          select.dispatchEvent(new Event("change", {bubbles:true}));
          sync();
        });
        group.appendChild(button);
      });
      function sync() {
        Array.from(group.children).forEach(function(button, index) {
          button.setAttribute("aria-pressed", String(button.dataset.value === select.value));
          button.disabled = select.options[index].disabled;
        });
      }
      select.addEventListener("change", sync);
      new MutationObserver(sync).observe(select, {subtree:true, attributes:true, attributeFilter:["disabled","selected"]});
      wrapper.appendChild(group);
      select.hidden = true;
      select.setAttribute("aria-hidden", "true");
      label.removeAttribute("for");
      wrapper.dataset.t5eChoices = "true";
      sync();
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {setup(document);});
  } else {
    setup(document);
  }
  document.addEventListener("shopify:section:load", function(event) {setup(event.target);});
}());
